import axios from "axios";
import {
  server,
  apiUrl,
  apiUrlAtlaw,
  apiUrlSME,
  NOT_CONNECT_NETWORK,
  NETWORK_CONNECTION_MESSAGE,
} from "@/services/constants";
import router from "@/router";
import api from "@/services/api";
import Swal from "sweetalert2";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

axios.defaults.baseURL = apiUrl;
axios.defaults.withCredentials = true; // ⭐ ใหม่

axios.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    const userToken = localStorage.getItem(server.TOKEN_KEY);
    if (userToken) {
      config.headers = {
        "x-access-token": userToken,
        authorization: `Bearer ${userToken}`,
      };
    }
    config.url = apiUrl + "/" + config.url;
    // console.log("httpClient:" + config.url);
  }
  config.timeout = 120000; // 10 Second
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else if (!error.response) {
      // network error / timeout
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Loading Failed',
      //   text: 'Unable to load data. Please check your internet connection and try again.',
      //   showConfirmButton: false, // ❌ ไม่แสดงปุ่ม OK
      //   timer: 2000,             // ⏱ แสดง 2 วินาทีแล้วปิดเอง
      //   timerProgressBar: true   // แถบเวลานับถอยหลัง (optional)
      // }).then(() => {
      //   // ✅ ดำเนินการต่อหลัง alert ปิด
      //   // เช่น redirect
      //   window.location.href = "/dashboard";
      // });

      return Promise.reject({
        code: NOT_CONNECT_NETWORK,
        message: NETWORK_CONNECTION_MESSAGE,
      });
    }

    const { response } = error;
    if (response.status === 401) {
      api.logoff();
      router.push("/login").catch(() => {});
    } else {
      router.push("/");
    }

    return Promise.reject(error);
  },
);

export default axios;

// for multi api
export const apiSMEMATE = axios.create({
  baseURL: apiUrlSME,
});
